export const SnackbarType = {
  LEFT: 'left',
  MIDDLE: 'middle',
  RIGHT: 'right'
};

const initialState = () => ({
  show: false,
  title: '',
  content: '',
  snackbarErrorText: '',
  snackbarCloseBtn: false,
  showModal: false
});

const state = {
  leftSnackbar: initialState(),
  middleSnackbar: initialState(),
  rightSnackbar: initialState(),

  //전체snackbar의 숨기기버튼 처리
  hideBtn: false
};

const mutations = {
  SHOW_SNACKBAR(state, { type }) {
    state[`${type}Snackbar`].show = true;
    console.log('테스트 state[',`${type}Snackbar`,'].show', state[`${type}Snackbar`].show);
  },
  SHOW_SNACKMODAL(state, { type }) {
    state[`${type}Snackbar`].showModal = true;
  },
  CLOSE_SNACKBAR_CLOSEBTN(state, { type }) {
    state[`${type}Snackbar`].snackbarCloseBtn = true;
  },
  CLOSE_SNACKBAR(state, { type }) {
    if(state[`${type}Snackbar`] == null){
      return;
    }
    Object.assign(state[`${type}Snackbar`], initialState());
  },
  SET_SNACKBAR_ERROR(state, { type, errorText }) {
    state[`${type}Snackbar`].snackbarErrorText = errorText;
  },
  SHOW_CLOSE_BUTTON(state, { type }) {
    state[`${type}Snackbar`].snackbarCloseBtn = true;
  },
  SHOW_MODAL(state, { type, content }) {
    state[`${type}Snackbar`].showModal = true;
    state[`${type}Snackbar`].content = content;
  },
  HIDE_MODAL(state, { type }) {
    state[`${type}Snackbar`].showModal = false;
    state[`${type}Snackbar`].content = '';
  },
  RESET_SNACKBAR(state, { type }) {
    Object.assign(state[`${type}Snackbar`], initialState());
  },
  SET_SNACKBAR_CONTENT(state, { type, content }) {
    state[`${type}Snackbar`].content = content;
  },
  SET_SNACKBAR_TITLE(state, { type, title }) {
    state[`${type}Snackbar`].title = title;
  }
  // HIDE_SNACKBAR(state) {
  // 	state.hideBtn = true;
  // }
};

const actions = {
  triggerSnackbar({ commit }, type) {
    commit('SHOW_SNACKBAR', { type });
  },
  closeSnackbar({ commit }, type) {
    commit('CLOSE_SNACKBAR', { type });
  },
  setSnackbarTitle({ commit }, { type, title }) {
    commit('SET_SNACKBAR_TITLE', { type, title });
  },
  setSnackbarContent({ commit }, { type, content }) {
    commit('SET_SNACKBAR_CONTENT', { type, content });
  },
  updateSnackbarProgress({ commit }, { type, progress }) {
    commit('UPDATE_SNACKBAR_PROGRESS', { type, progress });
  },
  setSnackbarError({ commit }, { type, errorText }) {
    commit('SET_SNACKBAR_ERROR', { type, errorText });
  },
  showCloseButton({ commit }, type) {
    commit('SHOW_CLOSE_BUTTON', { type });
  },
  showModal({ commit }, { type, content }) {
    commit('SHOW_MODAL', { type, content });
  },
  hideModal({ commit }, type) {
    commit('HIDE_MODAL', { type });
  },
  resetSnackbar({ commit }, type) {
    commit('RESET_SNACKBAR', { type });
  },
  closeSnackbarCloseBtn({ commit }, type) {
    commit('CLOSE_SNACKBAR_CLOSEBTN', { type });
  }
  // hideSnackbar({ commit }, type) {
  // 	commit("HIDE_SNACKBAR", { type });
  // }
};

const getters = {
  leftSnackbar: (state) => state.leftSnackbar,
  middleSnackbar: (state) => state.middleSnackbar,
  rightSnackbar: (state) => state.rightSnackbar,
  hideBtn: (state) => state.hideBtn
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
